import { Center, Loader, Stack, Text } from "@mantine/core";

export type FullPageLoaderProps = {
  /**
   * What is being waited for. Optional: most waits are short enough that a spinner alone
   * is the honest amount of information.
   */
  message?: string;
};

/**
 * A transient screen: the whole available box, and the app's one loading indicator. For
 * where the app has nothing to show *yet* and expects that to change on its own.
 *
 * It offers no action, which is the whole difference from `FullPageMessage`: that screen has
 * stopped and needs the user, this one has not and does not.
 * @param props
 * @param props.message
 */
export function FullPageLoader({ message }: FullPageLoaderProps) {
  return (
    <Center pos="absolute" inset={0} p="lg">
      <Stack align="center" gap="xs">
        {/* `type="bars"` is fixed rather than a prop: the app has one loading look, and
            two call sites agreeing on it by coincidence is what this component replaces */}
        <Loader type="bars" />
        {message ? (
          <Text c="var(--plantings-text-secondary-color)" ta="center">
            {message}
          </Text>
        ) : null}
      </Stack>
    </Center>
  );
}

FullPageLoader.displayName = "FullPageLoader";
